import { render, staticRenderFns } from "./studentLeaveList.vue?vue&type=template&id=183db055&scoped=true&"
import script from "./studentLeaveList.vue?vue&type=script&lang=js&"
export * from "./studentLeaveList.vue?vue&type=script&lang=js&"
import style0 from "./studentLeaveList.vue?vue&type=style&index=0&id=183db055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183db055",
  null
  
)

export default component.exports